// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --background: transparent;
}

.title-row {
  margin-top: 1.333rem;
}
.title-row .title {
  font-size: 1rem;
  color: white;
  text-align: center;
}

.bar {
  display: flex;
  text-align: center;
}
.bar .bar-image {
  margin-right: 0.563rem;
}

.buttons-style {
  position: absolute;
  left: 1rem;
  bottom: 4rem;
}
.buttons-style .btn-container {
  position: relative;
}
.buttons-style .btn-container .btn-icon {
  position: absolute;
  font-size: 1.333rem;
  color: var(--color-primary-blue);
  cursor: pointer;
}
.buttons-style .btn-container ion-img.btn-img::part(image) {
  width: 2.667rem;
  height: 2.667rem;
  cursor: pointer;
}
.buttons-style .btn-container .back {
  top: 0.667rem;
  left: 0.667rem;
}

.dimension-col {
  display: flex;
  justify-content: center;
}
.dimension-col .container {
  display: flex;
  justify-content: center;
  margin-top: 0.292rem;
  width: 45.667rem;
}
.dimension-col .container .dimension {
  margin-bottom: 0.5rem;
}
.dimension-col .container .dimension .rows {
  display: flex;
  flex-direction: column;
}
.dimension-col .container .dimension .rows .dimensions {
  display: flex;
  width: 100%;
  min-height: 2rem;
  align-items: center;
  border-radius: 16px 16px 0 0;
  background: rgba(39, 59, 90, 0.4);
}
.dimension-col .container .dimension .rows .dimensions .dimension-name {
  font-size: 1rem;
  color: white;
  white-space: nowrap;
  padding-left: 2.5rem;
}
.dimension-col .container .dimension .rows .dimensions .dimension-number {
  background: var(--color-yellow-bookmark) linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);
  font-size: 0.667rem;
  font-weight: bold;
  color: var(--color-primary-blue);
  padding: 0.2rem 0.2rem;
  border-radius: 50%;
  position: absolute;
  height: auto;
  margin-left: 0.667rem;
}
.dimension-col .container .dimension .group-row {
  padding-left: 0.667rem;
  padding-right: 0.667rem;
  background: rgba(39, 59, 90, 0.4);
  border-radius: 0 0 16px 16px;
  display: flex;
  align-items: center;
  height: 5.333rem;
}
.dimension-col .container .dimension .group-row .btn-container {
  position: relative;
  align-self: center;
  padding: 0.2rem;
}
.dimension-col .container .dimension .group-row .btn-container .btn-icon {
  position: absolute;
  font-size: 1rem;
  top: 0.5rem;
  left: 0.5rem;
  color: var(--color-primary-blue);
  cursor: pointer;
}
.dimension-col .container .dimension .group-row .btn-container ion-img.btn-img::part(image) {
  cursor: pointer;
}
.dimension-col .container .dimension .group-row .pull-left,
.dimension-col .container .dimension .group-row .pull-right {
  position: absolute;
  z-index: 5;
}
.dimension-col .container .dimension .group-row .pull-left {
  left: 0;
  width: 2rem;
  height: 100%;
  display: flex;
  background: rgba(0, 0, 0, 0.2);
  border-top-right-radius: 1rem;
  border-bottom-right-radius: 1rem;
}
.dimension-col .container .dimension .group-row .pull-right {
  right: 0;
  top: 0;
  width: 2rem;
  height: 100%;
  display: flex;
  background: rgba(0, 0, 0, 0.2);
  border-top-left-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
.dimension-col .container .dimension .group-row .groups::-webkit-scrollbar {
  display: none; /* for Chrome, Safari, and Opera */
}
.dimension-col .container .dimension .group-row .dimension-box {
  background-color: #07215E;
  width: 8.333rem;
  min-width: 8.333rem;
  height: 4.6rem;
  border-radius: 8px;
  margin-left: 0.333rem;
  padding: 0.3rem;
  text-align: center;
}
.dimension-col .container .dimension .group-row .dimension-box.highlightNoPosition {
  background: var(--color-yellow-bookmark) linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);
}
.dimension-col .container .dimension .group-row .dimension-box.highlightNoPosition .amount .icon-text-amount .text-amount {
  color: var(--color-primary-blue);
}
.dimension-col .container .dimension .group-row .dimension-box.highlightNoPosition .amount .countries-amount {
  color: var(--color-primary-blue);
}
.dimension-col .container .dimension .group-row .dimension-box .amount {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
}
.dimension-col .container .dimension .group-row .dimension-box .amount .icon-text-amount {
  display: flex;
  margin-bottom: 0.3rem;
  align-items: center;
}
.dimension-col .container .dimension .group-row .dimension-box .amount .icon-text-amount .text-amount {
  color: white;
  font-size: 1rem;
}
.dimension-col .container .dimension .group-row .dimension-box .amount .icon-text-amount .icon {
  height: 1.1rem;
  width: 1.4rem;
  margin-right: 0.563rem;
}
.dimension-col .container .dimension .group-row .dimension-box .amount .countries-amount {
  font-size: 1rem !important;
  color: white;
}
.dimension-col .container .dimension .group-row .groups {
  width: 37rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: scroll;
  overflow-y: hidden;
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
}
.dimension-col .container .dimension .group-row .groups .dim-results:last-child {
  margin-right: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/app/game/overview/overview.page.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;AACF;;AAEA;EACE,oBAAA;AACF;AACE;EACE,eAAA;EACA,YAAA;EACA,kBAAA;AACJ;;AAGA;EACE,aAAA;EACA,kBAAA;AAAF;AAEE;EACE,sBAAA;AAAJ;;AAIA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;AADF;AAGE;EACE,kBAAA;AADJ;AAGI;EACE,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,eAAA;AADN;AAII;EACE,eAAA;EACA,gBAAA;EACA,eAAA;AAFN;AAKI;EACE,aAAA;EACA,cAAA;AAHN;;AAQA;EACE,aAAA;EACA,uBAAA;AALF;AAOE;EACE,aAAA;EACA,uBAAA;EACA,oBAAA;EACA,gBAAA;AALJ;AAOI;EACE,qBAAA;AALN;AAOM;EACE,aAAA;EACA,sBAAA;AALR;AAOQ;EACE,aAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,4BAAA;EACA,iCAAA;AALV;AAOU;EACE,eAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;AALZ;AAQU;EACE,yHAAA;EACA,mBAAA;EACA,iBAAA;EACA,gCAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;AANZ;AAYM;EACE,sBAAA;EACA,uBAAA;EACA,iCAAA;EACA,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AAVR;AAYQ;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;AAVV;AAYU;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;EACA,eAAA;AAVZ;AAaU;EACE,eAAA;AAXZ;AAeQ;;EAEE,kBAAA;EACA,UAAA;AAbV;AAgBQ;EACE,OAAA;EAEA,WAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,6BAAA;EACA,gCAAA;AAfV;AAkBQ;EACE,QAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,4BAAA;EACA,+BAAA;AAhBV;AAmBQ;EACE,aAAA,EAAA,kCAAA;AAjBV;AAoBQ;EACE,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;AAlBV;AAoBU;EACE,yHAAA;AAlBZ;AAsBgB;EACE,gCAAA;AApBlB;AAwBc;EACE,gCAAA;AAtBhB;AA2BU;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;AAzBZ;AA2BY;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;AAzBd;AA2Bc;EACE,YAAA;EACA,eAAA;AAzBhB;AA4Bc;EACE,cAAA;EACA,aAAA;EACA,sBAAA;AA1BhB;AA8BY;EACE,0BAAA;EACA,YAAA;AA5Bd;AAiCQ;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,wBAAA,EAAA,gCAAA;EACA,qBAAA,EAAA,gBAAA;AA/BV;AAiCU;EACE,kBAAA;AA/BZ","sourcesContent":["ion-content {\n  --background: transparent;\n}\n\n.title-row {\n  margin-top: 1.333rem;\n\n  .title {\n    font-size: 1rem;\n    color: white;\n    text-align: center;\n  }\n}\n\n.bar {\n  display: flex;\n  text-align: center;\n\n  .bar-image {\n    margin-right: 0.563rem;\n  }\n}\n\n.buttons-style {\n  position: absolute;\n  left: 1rem;\n  bottom: 4rem;\n\n  .btn-container {\n    position: relative;\n\n    .btn-icon {\n      position: absolute;\n      font-size: 1.333rem;\n      color: var(--color-primary-blue);\n      cursor: pointer;\n    }\n\n    ion-img.btn-img::part(image) {\n      width: 2.667rem;\n      height: 2.667rem;\n      cursor: pointer;\n    }\n\n    .back {\n      top: 0.667rem;\n      left: 0.667rem;\n    }\n  }\n}\n\n.dimension-col {\n  display: flex;\n  justify-content: center;\n\n  .container {\n    display: flex;\n    justify-content: center;\n    margin-top: 0.292rem;\n    width: 45.667rem;\n\n    .dimension {\n      margin-bottom: 0.5rem;\n\n      .rows {\n        display: flex;\n        flex-direction: column;\n\n        .dimensions {\n          display: flex;\n          width: 100%;\n          min-height: 2rem;\n          align-items: center;\n          border-radius: 16px 16px 0 0;\n          background: rgba(39, 59, 90, 0.4);\n\n          .dimension-name {\n            font-size: 1rem;\n            color: white;\n            white-space: nowrap;\n            padding-left: 2.5rem;\n          }\n\n          .dimension-number {\n            background: var(--color-yellow-bookmark) linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);\n            font-size: 0.667rem;\n            font-weight: bold;\n            color: var(--color-primary-blue);\n            padding: 0.2rem 0.2rem;\n            border-radius: 50%;\n            position: absolute;\n            height: auto;\n            margin-left: 0.667rem;\n          }\n        }\n      }\n\n\n      .group-row {\n        padding-left: 0.667rem;\n        padding-right: 0.667rem;\n        background: rgba(39, 59, 90, 0.4);\n        border-radius: 0 0 16px 16px;\n        display: flex;\n        align-items: center;\n        height: 5.333rem;\n\n        .btn-container {\n          position: relative;\n          align-self: center;\n          padding: 0.2rem;\n\n          .btn-icon {\n            position: absolute;\n            font-size: 1rem;\n            top: 0.5rem;\n            left: 0.5rem;\n            color: var(--color-primary-blue);\n            cursor: pointer;\n          }\n\n          ion-img.btn-img::part(image) {\n            cursor: pointer;\n          }\n        }\n\n        .pull-left,\n        .pull-right {\n          position: absolute;\n          z-index: 5;\n        }\n\n        .pull-left {\n          left: 0;\n          //top: 30%;\n          width: 2rem;\n          height: 100%;\n          display: flex;\n          background: rgba(0, 0, 0, 0.2);\n          border-top-right-radius: 1rem;\n          border-bottom-right-radius: 1rem;\n        }\n\n        .pull-right {\n          right: 0;\n          top: 0;\n          width: 2rem;\n          height: 100%;\n          display: flex;\n          background: rgba(0, 0, 0, 0.2);\n          border-top-left-radius: 1rem;\n          border-bottom-left-radius: 1rem;\n        }\n\n        .groups::-webkit-scrollbar {\n          display: none; /* for Chrome, Safari, and Opera */\n        }\n\n        .dimension-box {\n          background-color: #07215E;\n          width: 8.333rem;\n          min-width: 8.333rem;\n          height: 4.6rem;\n          border-radius: 8px;\n          margin-left: 0.333rem;\n          padding: 0.3rem;\n          text-align: center;\n\n          &.highlightNoPosition {\n            background: var(--color-yellow-bookmark) linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);\n\n            .amount {\n              .icon-text-amount {\n                .text-amount {\n                  color: var(--color-primary-blue);\n                }\n              }\n\n              .countries-amount {\n                color: var(--color-primary-blue);\n              }\n            }\n          }\n\n          .amount {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            flex-direction: column;\n            height: 100%;\n\n            .icon-text-amount {\n              display: flex;\n              margin-bottom: 0.3rem;\n              align-items: center;\n\n              .text-amount {\n                color: white;\n                font-size: 1rem;\n              }\n\n              .icon {\n                height: 1.1rem;\n                width: 1.4rem;\n                margin-right: 0.563rem;\n              }\n            }\n\n            .countries-amount {\n              font-size: 1rem !important;\n              color: white;\n            }\n          }\n        }\n\n        .groups {\n          width: 37rem;\n          display: flex;\n          flex-direction: row;\n          align-items: center;\n          overflow: scroll;\n          overflow-y: hidden;\n          -ms-overflow-style: none; /* for Internet Explorer, Edge */\n          scrollbar-width: none; /* for Firefox */\n\n          .dim-results:last-child {\n            margin-right: 1rem;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
